import { TFunction } from 'i18next/typescript/t';
import * as Yup from 'yup';

interface IProps {
	t: TFunction<'translation', undefined>;
}

const reportAddFileModalValidation = ({ t }: IProps) =>
	Yup.object().shape({
		name: Yup.string().required(t('validationMessages.mandatory')),
		type: Yup.string().required(t('validationMessages.mandatory')),
		file: Yup.string().required(t('validationMessages.fileRequired')),
	});
export default reportAddFileModalValidation;
